import React, { useContext } from 'react';

import { faFacebook, faTwitter, faLinkedin, faInstagram, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import NavLinks from '../Navigation/NavLinks';
import { AuthContext } from '../../context/auth-context';
import { useStoreDetailsContext } from '../../context/store-details-context';
import { useThemeContext } from '../../context/theme-context';
import { appConfig } from '../../strings/stringsConfig';
import useTranslation from '../../Hooks/translation-hook';
import getLocalizedValue from '../../util/get-localized-value';
import { config } from '../../../config';

import './MainFooter.css';

const MainFooter = props => {
    const auth = useContext(AuthContext);
    const { t, currentLanguage } = useTranslation();
    const {
        storeDetails,
        isUpdatedStoreDetails,
        HideStoreDetailsSkeleton,
    } = useStoreDetailsContext();

    const {
        isUpdatedTheme,
        HideThemeSkeleton,
    } = useThemeContext();

    const storeName = getLocalizedValue(storeDetails?.name, currentLanguage);
    const storeDescription = getLocalizedValue(storeDetails?.description, currentLanguage);
    const storeAddress = getLocalizedValue(storeDetails?.address, currentLanguage);
    const storeWorkingHours = getLocalizedValue(storeDetails?.workingHours, currentLanguage);

    return (
        (auth.role === "admin" || (isUpdatedStoreDetails && isUpdatedTheme && HideThemeSkeleton && HideStoreDetailsSkeleton)) ? (
            <footer className="main-footer">
                {(storeDetails?.image && storeName && storeDescription) &&
                    <div className="footer-upper-container align-center full-width">
                        {storeDetails?.image &&
                            <div className='footer-about-image-container'>
                                <img loading='lazy' src={`${config.SERVER_URL}/${storeDetails.image}`} alt="Footer Store" />
                            </div>
                        }
                        {storeName &&
                            <p className='store-title'>
                                {storeName}
                            </p>
                        }
                        {storeDescription &&
                            <p className='store-description'>
                                {storeDescription}
                            </p>
                        }
                    </div>
                }
                {/* {auth.role !== "viewer" &&
                    <div className="footer-upper-container text-center full-width margin-forty">
                        <p className='title'>{t('mainFooter.quickLinksTitle')}</p>
                        <NavLinks showLogout={false} classes="footer-links" />
                    </div>
                } */}
                {(storeAddress && storeDetails?.phone) &&
                    <div className="footer-upper-container margin-forty">
                        <p className='title'>{t('mainFooter.contactInfoTitle')}</p>
                        {storeAddress &&
                            <div className='contact-info-content'>
                                <p className='bold'>
                                    {t('mainFooter.addressLabel')}
                                </p>
                                <p>
                                    {storeAddress}
                                </p>
                            </div>
                        }
                        {storeDetails?.phone &&
                            <div className='contact-info-content'>
                                <p className='bold'>
                                    {t('mainFooter.phoneLabel')}
                                </p>
                                <p>
                                    {storeDetails?.phone}
                                </p>
                            </div>
                        }
                        {storeWorkingHours &&
                            <div className='contact-info-content'>
                                <p className='bold'>
                                    {t('mainFooter.workingHoursLabel')}
                                </p>
                                <p>
                                    {storeWorkingHours}
                                </p>
                            </div>
                        }
                    </div>
                }
                <hr />
                <div className="footer-lower-container">
                    <div className="icons">
                        {storeDetails?.facebook &&
                            <div>
                                <a href={storeDetails.facebook} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faFacebook} className="facebook-icon icon" />
                                </a>
                            </div>
                        }
                        {storeDetails?.twitter &&
                            <div>
                                <a href={storeDetails.twitter} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faTwitter} className="twitter-icon icon" />
                                </a>
                            </div>
                        }

                        {storeDetails?.linkedin &&
                            <div>
                                <a href={storeDetails.linkedin} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faLinkedin} className="linkedin-icon icon" />
                                </a>
                            </div>
                        }
                        {storeDetails?.instagram &&
                            <div>
                                <a href={storeDetails.instagram} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faInstagram} className="instagram-icon icon" />
                                </a>
                            </div>
                        }
                        {storeDetails?.youtube &&
                            <div>
                                <a href={storeDetails.youtube} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faYoutube} className="youtube-icon icon" />
                                </a>
                            </div>
                        }
                        {storeDetails?.tiktok &&
                            <div>
                                <a href={storeDetails.tiktok} target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faTiktok} className="tiktok-icon icon" />
                                </a>
                            </div>
                        }
                    </div>
                    <p>
                        {`© ${new Date().getFullYear()} ${storeName || appConfig.brand}. ${t('mainFooter.copyrightSuffix')}`}
                    </p>
                    <p>{t('mainFooter.poweredBy')}</p>
                </div>
            </footer>) : null
    );
}

export default MainFooter;